import { Link } from "react-router-dom";

import { PageWrapper, CenteredText } from "./components";

export const PageNotFound = () => {
    return <PageWrapper>
        <CenteredText>This is not the page you're looking for...</CenteredText>
    </PageWrapper>
}

export const LandscapeRedirect = () => {
    return <PageWrapper>
        <CenteredText>
            <div>The Biopharma AI Landscape has been replaced by the</div>
            <div><Link to='/directory/'>Digital Tool Directory</Link></div>
        </CenteredText>
    </PageWrapper>
}

export const VCMRedirect = () => {
    return <PageWrapper>
        <CenteredText>
            <div>The Buyer's Guide to Virtual Cell Models has been replaced by the</div>
            <div><Link to='/directory/vcm/'>Digital Tool Directory</Link></div>
        </CenteredText>
    </PageWrapper>
}

export const DopRedirect = () => {
    return <PageWrapper>
        <CenteredText>
            <div>The Guide to Data Operations Plans has been replaced by the</div>
            <div><Link to='/frameworks/'>Reference Frameworks</Link></div>
        </CenteredText>
    </PageWrapper>
}

export const RiskReviewRedirect = () => {
    return <PageWrapper>
        <CenteredText>
            <div>I no longer offer free risk reviews, but I do do customized assessments and reviews for many clients.</div>
            <div>You can learn more on the <Link to='/'>main page</Link>.</div>
        </CenteredText>
    </PageWrapper>
}
